export function setFormDatalayer(dataset) {
    const response = { 'event': 'form_complete', 'page_location': window.location.href };

    if (dataset?.formCategory)
        response['form_category'] = dataset.formCategory;
    if (dataset?.formCategory1)
        response['form_category_1'] = dataset.formCategory1;
    if (dataset?.formTitle)
        response['form_title'] = dataset.formTitle;
    if (dataset?.pageCategory)
        response['page_category'] = dataset.pageCategory;
    if (dataset?.pageCategory1)
        response['page_category_1'] = dataset.pageCategory1;
    if (dataset?.pageCategory2)
        response['page_category_2'] = dataset.pageCategory2;
    if (dataset?.vacancyTitle)
        response['vacancy_title'] = dataset.vacancyTitle;
    if (dataset?.vacancyLocation)
        response['vacancy_location'] = dataset.vacancyLocation;
    if (dataset?.pageTitle)
        response['page_title'] = dataset.pageTitle;

    return response;
}